import { FormikValues, useFormikContext } from "formik";
import React from "react";
import InputField from "../../common/form/input/InputField";

type Props = {
  name: string;
  type?: string;
  placeholder: string;
  label: string;
  [x: string]: any;
};

const BedStatusInputField = (props: Props) => {
  const { name, label, placeholder, type = "number", ...rest } = props;

  const { values } = useFormikContext<FormikValues>();

  return (
    <div className="form-group">
      <label className="mb-1 form-label">{label}</label>
      <InputField
        type={type}
        className="form-control form-control-sm"
        name={name}
        value={values[name]}
        required
        placeholder={placeholder}
        {...rest}
      />
    </div>
  );
};

export default BedStatusInputField;
